import { createExternalRouteRef } from '@backstage/core-plugin-api';

export const searchRouteRef = createExternalRouteRef({
  id: 'search',
});
